import * as THREE from 'three'

/* eslint-disable */
const vertices = new Float32Array([
  5,  0,  0,
 -5,  0,  0,
  2, -1,  0,
  1,  2, -6,
  3,  0,  0,
 -1,  0,  0,
  1,  2,  6,
  3,  0,  0,
 -1,  0,  0
])
/* eslint-enable */

export default class BirdGeometry extends THREE.BufferGeometry {
  constructor () {
    super()
    this.setAttribute('position',
      new THREE.BufferAttribute(vertices.slice(), 3)
    )
  }
}
